import { Component, OnInit, Inject } from '@angular/core';
import { ClassTemplate } from '../../models/classTemplate';
import { ClassTemplateService } from '../../services/class-template.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-add-gym-to-class-templates',
  templateUrl: './add-gym-to-class-templates.component.html',
  styleUrls: ['./add-gym-to-class-templates.component.scss']
})
export class AddGymToClassTemplatesComponent implements OnInit {
  public listOfClassTemplates: Array<ClassTemplate> = [];
  public optionChosen = 'all';
  public templateSelected: any = {};

  constructor(
    private classTemplateService: ClassTemplateService,
    public dialogRef: MatDialogRef<AddGymToClassTemplatesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.classTemplateService.getClassTemplatesOwnedBy(this.data.ownedBy).then((classTemplates) => {
      this.listOfClassTemplates = classTemplates;
      classTemplates.forEach((classTemplate: any) => {
        if (classTemplate._id) {
          this.templateSelected[classTemplate._id] = true;
        }
      });
    });
  }

  public addGymToClassTemplates() {
    if (this.optionChosen === 'none') {
      this.dialogRef.close();
    } else {
      const promisesToCall: Array<Promise<any>> = [];
      for (const templateId in this.templateSelected) {
        if (this.templateSelected[templateId] === true) {
          this.classTemplateService.addGymToClassTemplate(templateId, this.data.gymId);
        }
      }
      Promise.all(promisesToCall).then(() => {
        this.dialogRef.close();
      }, (err: any) => {
        this.dialogRef.close();
      });
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/add-gym-to-class-templates/add-gym-to-class-templates.component.ts